module.exports = __webpack_public_path__ + "4324c1552bc15e50832b7537bbe79163.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/dashboard-roster.png
// module id = 1036
// module chunks = 0